export default __webpack_public_path__ + "static/iso_security_compliance-8b653957465ee3cf78f6804e73b22bcc.png";